export default __webpack_public_path__ + "static/media/img_book.cb2cbdd8.png";